let Backbone = require("backbone");
let POS = require("../POS.js");
let $ = require('jquery');
let _ = require("underscore");

let main = function (Backbone, POS) {
    var ChooseMemberModalView = Backbone.View.extend({
        el: "#chooseMemberModal",
        initialize: function () {
            let self = this;
            let options = this.$el.find("option");
            _.each(options, function (option) {
                if ($(option).val() != "0" && $(option).data("authorities").indexOf(self.options.type) == -1) {
                    $(option).addClass("hidden");
                } else {
                    $(option).removeClass("hidden");
                }
            });
        },
        events: {
            'click .chooseStaffBtn': '_chooseStaff'
        },
        _chooseStaff: function () {
            var self = this, jxhr;
            if(this.$el.find('.chooseStaff').val() == "0"){
                alert("请选择员工");
                return false;
            }
            var staff = {
                evt: this.options.evt,
                id: this.$el.find('.chooseStaff').val(),
                name: this.$el.find('.chooseStaff option:selected').text().trim()
            };
            self.trigger('chooseStaff', staff);
        },
        show: function () {
            this.$el.modal("show");
        },
        hide: function () {
            this.$el.modal("hide");
        }
    });

    return ChooseMemberModalView;
};

let exportedValue = main(Backbone, POS);
module.exports = exportedValue;


// WEBPACK FOOTER //
// ./src/view/ChooseMemberModalView.js